import { Injectable } from '@angular/core';

import { TranslateService } from '@ngx-translate/core';

import * as moment from 'moment';

@Injectable({
  providedIn: 'root',
})
export class DateService {
  constructor(private translateService: TranslateService) {}

  today() {
    return moment();
  }

  startOfMonth() {
    return moment().startOf('month');
  }

  format(date, format = '') {
    if (format) {
      return moment(date).format(format);
    }

    return moment(date);
  }

  // 2030-05-01T06:00:00.000Z
  startOfDayFormat(date) {
    return moment(date).startOf('day').toISOString();
  }

  // 2030-05-19T05:59:59.999Z
  endOfDayFormat(date) {
    return moment(date).endOf('day').toISOString();
  }

  // UTC
  startOfDayUTCFormat(date) {
    return moment(date).utc().startOf('day').toISOString();
  }

  // UTC
  endOfDayUTCFormat(date) {
    return moment(date).utc().endOf('day').toISOString();
  }

  setDatePickerRangeOptions(options) {
    const todayLabel = this.translateService.instant('TODAY');
    const yesterdayLabel = this.translateService.instant('YESTERDAY');
    const thisWeekLabel = this.translateService.instant('THIS_WEEK');
    const lastWeekLabel = this.translateService.instant('LAST_WEEK');
    const thisMonthLabel = this.translateService.instant('THIS_MONTH');
    const lastMonthLabel = this.translateService.instant('LAST_MONTH');
    const nextMonthLabel = this.translateService.instant('NEXT_MONTH');

    let dateRanges = {};

    if (options.today) {
      dateRanges[todayLabel] = [moment(), moment()];
    }

    if (options.yesterday) {
      dateRanges[yesterdayLabel] = [moment().subtract(1, 'days'), moment().subtract(1, 'days')];
    }

    if (options.this_week) {
      dateRanges[thisWeekLabel] = [moment().startOf('week'), moment().endOf('week')];
    }

    if (options.last_week) {
      dateRanges[lastWeekLabel] = [moment().subtract(6, 'days'), moment()];
    }

    if (options.this_month) {
      dateRanges[thisMonthLabel] = [moment().startOf('month'), moment().endOf('month')];
    }

    if (options.last_month) {
      dateRanges[lastMonthLabel] = [
        moment().subtract(1, 'month').startOf('month'),
        moment().subtract(1, 'month').endOf('month'),
      ];
    }

    if (options.next_month) {
      dateRanges[nextMonthLabel] = [
        moment().add(1, 'months').startOf('month'),
        moment().add(1, 'months').endOf('month'),
      ];
    }

    return dateRanges;
  }

  // Convert hh:mm to Date, to use it with angular date pipe
  setTime(value): Date {
    let time = new Date();

    if (value) {
      let timeSplit = value.split(':');

      time.setHours(Number(timeSplit[0]), Number(timeSplit[1]));

      return time;
    }
    return new Date(time);
  }

  // To validate a date that is formatted as MM/DD/YYYY
  isValidDate(dateStr) {
    const regex = /^\d{2}\/\d{2}\/\d{4}$/;

    if (dateStr.match(regex) === null) {
      return false;
    }

    const [month, day, year] = dateStr.split('/');

    // 👇️ format Date string as `yyyy-mm-dd`
    const isoFormattedStr = `${year}-${month}-${day}`;

    const date = new Date(isoFormattedStr);

    const timestamp = date.getTime();

    if (typeof timestamp !== 'number' || Number.isNaN(timestamp)) {
      return false;
    }

    return date.toISOString().startsWith(isoFormattedStr);
  }
}

// const date = new Date();
// return new Date(date.getFullYear(), date.getMonth(), 1);
